import { render } from "./userTab.vue?vue&type=template&id=974c3580&scoped=true&ts=true"
import script from "./userTab.vue?vue&type=script&lang=ts&config=true"
export * from "./userTab.vue?vue&type=script&lang=ts&config=true"

import "./userTab.vue?vue&type=style&index=0&id=974c3580&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-974c3580"]])

export default __exports__